omadapp.singletons.gestorTransiciones = new(function() {
    var t = this;
    var $ = jQuery
    t.generarTransicion = generarTransicion
    t.velTransicion = 1000
    t.velNegro=500
    t.transicionando = false

    var transiciones = {
        "corte": corte,
        "slideUp": slideUp,
        "slideDown": slideDown,
        "slideLeft": slideLeft,
        "slideRight": slideRight,
        "fundido": fundido,
        "fundidoNegro": fundidoNegro,

    }

    function generarTransicion(entrante, saliente, transicion, params, callback) {
        transicion = transicion || "corte"
        if (t.transicionando) {
            console.trace ("llamada a generar transición mientras está en marcha")
            return false
        }
       // trace ("generarTransicion")
       // trace (saliente)
       // trace (entrante)
        if (saliente&&saliente.onPreExit) {
            saliente.onPreExit(function(validate) {
                if (validate) {
                    do_transition()
                }
            })
        } else {
            do_transition()
        }

        function do_transition () {
           // trace ("do_transition")
          //  trace (t)
            t.transicionando = true
           // trace (entrante)
            if (entrante){
                entrante.$page.addClass("animando")
                if (entrante.onPreCurrent) entrante.onPreCurrent()
            }

            if (saliente){saliente.$page.addClass("animando")}
            transiciones[transicion](entrante, saliente, params,cb )

            function cb(entrante, saliente) {
                t.transicionando = false;
                if (entrante){entrante.$page.removeClass("animando")}
                if (saliente){saliente.$page.removeClass("animando")}
                  //  trace (callback)
                if (callback) {callback(entrante, saliente)}
            }
        }
    }

    function corte(entrante, saliente, params, callback) {
        trace("gestorTransiciones::corte")
        //trace(entrante)
        //trace(saliente)
        
        entrante.$page.addClass("current")
        if (entrante.onCurrent) {
            entrante.onCurrent()
        }
        if (saliente) {
            if (saliente!=entrante) saliente.$page.removeClass("current")
            if (saliente.onExit) {
                saliente.onExit()
            }
            if (saliente.closeScene) {
                saliente.closeScene()
            }

        }

        if (callback) callback(entrante, saliente)
        
        if (entrante.onPostCurrent) {
            entrante.onPostCurrent()
        }
    }

    function adaptarOpciones(params) {
        var res = {
            velTransicion: t.velTransicion,
            velNegro: t.velNegro
        }

        if (!params) return res;
        for (var n in res) {
            if (params[n]) res[n] = params[n]
        }
        return res
    }

    function slideLeft(entrante, saliente, params, callback) {
        params = adaptarOpciones(params)
        trace("gestorTransiciones::slideLeft")
       // trace(params)
        var $entrante = entrante.$page
        var $saliente = saliente.$page
       // trace($entrante)
       // trace($saliente)

        $entrante.css({
            left: "100%"
        })
        $entrante.addClass("current")
        $entrante.stop().animate({ left: 0 }, params.velTransicion, finTransicion)
        $saliente.stop().animate({ left: "-100%" }, params.velTransicion)


        function finTransicion() {
            if (entrante.onCurrent) {
                entrante.onCurrent()
            }
            if (saliente) {
                $saliente.removeClass("current")

                if (saliente.onExit) {
                    saliente.onExit()
                }
                if (saliente.closeScene) {
                    saliente.closeScene()
                }

            }
            setTimeout(function() {
                $saliente.attr("style", "")
                $entrante.attr("style", "")
            }, 100)
            if (callback) callback(entrante, saliente)
        }
    }
    function slideUp(entrante, saliente, params, callback) {
        params = adaptarOpciones(params)
        trace("gestorTransiciones::slideUp")
        //trace(params)
        var $entrante = entrante.$page
        var $saliente = saliente.$page
       // trace($entrante)
       // trace($saliente)

        $entrante.css({
            top: "100%"
        })
        $entrante.addClass("current")
        $entrante.stop().animate({ top: 0 }, params.velTransicion, finTransicion)
        $saliente.stop().animate({ top: "-100%" }, params.velTransicion)


        function finTransicion() {
            if (entrante.onCurrent) {
                entrante.onCurrent()
            }
            if (saliente) {
                $saliente.removeClass("current")

                if (saliente.onExit) {
                    saliente.onExit()
                }
                if (saliente.closeScene) {
                    saliente.closeScene()
                }

            }
            setTimeout(function() {
                $saliente.attr("style", "")
                $entrante.attr("style", "")
            }, 100)
            if (callback) callback(entrante, saliente)
        }
    }

    function slideDown(entrante, saliente, params, callback) {
        params = adaptarOpciones(params)
        trace("gestorTransiciones::slideUp")
        //trace(params)
        var $entrante = entrante.$page
        var $saliente = saliente.$page
        //trace($entrante)
        //trace($saliente)

        $entrante.css({
            top: "-100%"
        })
        $entrante.addClass("current")
        $entrante.stop().animate({ top: 0 }, params.velTransicion, finTransicion)
        $saliente.stop().animate({ top: "100%" }, params.velTransicion)


        function finTransicion() {
            if (entrante.onCurrent) {
                entrante.onCurrent()
            }
            if (saliente) {
                $saliente.removeClass("current")

                if (saliente.onExit) {
                    saliente.onExit()
                }
                if (saliente.closeScene) {
                    saliente.closeScene()
                }

            }
            setTimeout(function() {
                $saliente.attr("style", "")
                $entrante.attr("style", "")
            }, 100)
            if (callback) callback(entrante, saliente)
        }
    }

    function slideRight(entrante, saliente, params, callback) {
        params = adaptarOpciones(params)
        trace("gestorTransiciones::slideRight")
        //trace(params)
        var $entrante = entrante.$page
        var $saliente = saliente.$page
       // trace($entrante)
       // trace($saliente)

        $entrante.css({
            left: "-100%"
        })
        $entrante.addClass("current")
        $entrante.stop().animate({ left: 0 }, params.velTransicion, finTransicion)
        $saliente.stop().animate({ left: "100%" }, params.velTransicion)


        function finTransicion() {
            if (entrante.onCurrent) {
                entrante.onCurrent()
            }
            if (saliente) {
                $saliente.removeClass("current")

                if (saliente.onExit) {
                    saliente.onExit()
                }
                if (saliente.closeScene) {
                    saliente.closeScene()
                }

            }
            setTimeout(function() {
                $saliente.attr("style", "")
                $entrante.attr("style", "")
            }, 100)
            if (callback) callback(entrante, saliente)
        }
    }

    function fundido(entrante, saliente, params, callback) {
        params = adaptarOpciones(params)

        var $entrante = entrante.$page
        var $saliente = saliente.$page
        //trace($entrante)
        //trace($saliente)

        $entrante.css({
            opacity: "0"
        })
        $entrante.addClass("current")
        $entrante.stop().animate({ opacity: 1 }, params.velTransicion, finTransicion)
        $saliente.stop().animate({ opacity: 0 }, params.velTransicion)


        function finTransicion() {
            if (entrante.onCurrent) {
                entrante.onCurrent()
            }
            if (saliente) {
                $saliente.removeClass("current")

                if (saliente.onExit) {
                    saliente.onExit()
                }
                if (saliente.closeScene) {
                    saliente.closeScene()
                }

            }
            setTimeout(function() {
                $saliente.attr("style", "")
                $entrante.attr("style", "")
            }, 100)
            if (callback) callback(entrante, saliente)
        }
    }

    function fundidoNegro(entrante, saliente, params, callback) {
        params = adaptarOpciones(params)

        var $entrante = entrante.$page
        var $saliente = saliente.$page
        //trace($entrante)
        //trace($saliente)
        //trace ("fundidoNegro --------")
        //trace (params.velNegro)
        $entrante.css({
            opacity: "0"
        })
        $entrante.addClass("current")
        $saliente.stop().animate({ opacity: 0 }, params.velTransicion / 2, function() {
            setTimeout(function () {
                $entrante.stop().animate({ opacity: 1 }, params.velTransicion / 2, finTransicion)
            },params.velNegro)
        })


        function finTransicion() {
            if (saliente) {
                $saliente.removeClass("current")

                if (saliente.onExit) {
                    saliente.onExit()
                }
                if (saliente.closeScene) {
                    saliente.closeScene()
                }

            }
            if (entrante.onCurrent) {
                entrante.onCurrent()
            }
            setTimeout(function() {
                $saliente.attr("style", "")
                $entrante.attr("style", "")
            }, 100)
            if (callback) callback(entrante, saliente)
        }
    }

})